import { IComponentOptions } from "angular";
import { AmendmentsViewController } from "./controller";

export const vsComponentName = "masterAgreementAmendmentsComponent";
export const contractAmendmentsComponentOptions: IComponentOptions = {
  controller: AmendmentsViewController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    amendments: "<",
    amendmentId: "<?",
  },
};
